import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import { getAuthorization, useAuth } from "../../../lib/auth";
import LoginForm from "../../../components/LoginForm/LoginForm";

export default function Login() {
  // let history = useHistory();
  // let location = useLocation();
  let auth = useAuth();
  const [redirect, setRedirect] = useState(false);
  const [redirectLink, setredirectLink] = useState();

  // let { from } = location.state || { from: { pathname: "/" } };
  // let login = () => {
  //   auth.signin(() => {
  //     history.replace(from);
  //   });
  // };

  useEffect(() => {
    if (getAuthorization()) {
      setredirectLink("/dashboard");
      setRedirect(true);
    }
  }, [auth.user]);

  if (redirect) {
    return <Redirect to={redirectLink} />;
  }

  return (
    <div>
      <LoginForm />
    </div>
  );
}
